<template>
  <moe-page>
    <moe-top></moe-top>
    <div class="coupon_box flex Flexjustify">
      <div class="coupon_content">
        <div class="flex Flexalign FlexBetween content_top">
          <div>实名认证</div>
          <div class="flex Flexalign cursor_pointer" @click="back">
            <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
            <div class="mar_left_10">返回</div>
          </div>
        </div>
        <div class="content">
          <div class="password_info flex mar_top_20">
            <div class="password_label">真实姓名：</div>
            <el-input v-model="realInfo.userName" size="large" style="width: 220px; height: 36px" placeholder="" />
          </div>
          <div class="password_info flex mar_top_20">
            <div class="password_label">身份证号：</div>
            <div class="password_value">
              <el-input v-model="realInfo.identity" size="large" style="width: 220px; height: 36px" placeholder="" />
              <div class="mar_top_10 password_attention">
                身份证号要与输入姓名保持一致。
              </div>
            </div>
          </div>
          <div class="btn_save mar_top_50 cursor_pointer" @click="confirm">提交</div>
        </div>
      </div>
    </div>
  </moe-page>
</template>

<script>
export default {
  name: "GjkcH5RealNameVerify",

  components: {},
  data() {
    return {
      realInfo:{
        userName:'',
        identity:'',
      }
    };
  },

  mounted() { },

  methods: {
    confirm(){
      if(!this.realInfo.userName || !this.realInfo.identity){
         this.$Dialog.toast("输入不能为空", { type: "error" });
        return;
      }
      this.$Api.user.realNameVerify(this.realInfo).then(()=>{
        this.$Dialog.toast("实名认证成功");
          setTimeout(() => {
            this.back();
          }, 1000);
      }).catch(()=>{})
    }
  },
};
</script>
<style lang="scss" scoped>
.coupon_box {
  width: 100%;
  min-height: calc(100vh - $pageTopHeight);
  background: #f3f3f3;

  .coupon_content {
    margin-top: 20px;
    box-sizing: border-box;
    width: $pageMainWidth;
    height: 600px;
    background: #ffffff;
    border-radius: 10px;
    padding: 20px;

    .content_top {
      font-size: 18px;
      color: #13d6aa;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);
      padding-bottom: 15px;

      .back_icon {
        width: 24px;
        height: 24px;
      }
    }

    .content {
      .password_info {
        .password_label {
          line-height: 36px;
          width: 120px;
          font-size: 18px;
          color: #333333;
        }

        .password_value {
          .strength_box {
            width: 220px;

            .strength_one {
              width: 67px;
              height: 34px;
              background: #ebebeb;
              line-height: 34px;
              text-align: center;
              color: #333333;
              font-weight: 600;
            }
          }

          .password_attention {
            font-size: 14px;
            color: #ff6619;
          }
        }
      }

      .btn_save {
        width: 124px;
        height: 36px;
        background: linear-gradient(90deg, #00d5c2, #00d498);
        border-radius: 18px;
        text-align: center;
        line-height: 36px;
        color: #ffffff;
      }
    }
  }
}
</style>